module.exports = __webpack_public_path__ + "static/media/nature-background.8f69ee83.png";